import * as React from 'react';
import styled from 'styled-components';

import { Checkbox } from '../../../../ui/form/Checkbox';
import { AreaSubFilter, IAreaOption } from './AreaSubFilter';

import { FilterCheckboxWrapper, FilterComponentStyle } from './BaseAreaFilter';
import { SearchAggregation } from '../../../../../__types__/generated/cluster';

interface IArgs {
  counties?: Partial<SearchAggregation>[];
  municipalities?: Partial<SearchAggregation>[];
  selectedCounties?: string[];
  selectedMunicipalities?: IAreaOption[];
  onCountyClick: (value: string) => void;
  onMunicipalityClick: (value: string, parent?: string) => void;
}

export const AreaFilter: React.FC<IArgs> = React.memo(
  ({
    counties = [],
    municipalities = [],
    selectedCounties = [],
    selectedMunicipalities = [],
    onCountyClick,
    onMunicipalityClick
  }) => {
    return (
      <FilterComponentStyle>
        {counties?.map((item, index) => {
          const { count = 0, key = null } = item;
          if (!count || !key) return null;
          return (
            <FilterCheckboxWrapper key={`county_${index}`}>
              <Checkbox
                checked={selectedCounties?.includes(key)}
                labelPos="right"
                label={item.key}
                count={count}
                onClick={() => onCountyClick(key)}
              />
              {selectedCounties.includes(key) ? (
                <AreaSubFilter
                  parentKey={key}
                  options={municipalities}
                  selected={selectedMunicipalities}
                  onClick={onMunicipalityClick}
                />
              ) : null}
            </FilterCheckboxWrapper>
          );
        })}
      </FilterComponentStyle>
    );
  }
);
